import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './FormDivider.scss';

const FormDivider = () => {
    return (
        <div className="auth-lib__form-divider  eds-l-pad-bot-6">
            <div className="auth-lib__form-divider-text eds-text-bm eds-text-weight--heavy">
                {gettext('or')}
            </div>
        </div>
    );
};

export default FormDivider;
